module.exports = __webpack_public_path__ + "media/images/policy-1997ad2abaf54faedded3427d1db0f76.svg";